import React, { HTMLAttributes, ReactElement } from 'react'
import { getPaneTypeClassModifier } from './helpers/get-pane-type-class-modifier'
import { LayoutSidebarPaneType } from './types-and-constants/LayoutPaneTypesAndConstants'
import { getRetainBehaviorModifierForPane } from '../helpers/get-retain-behavior-for-pane'
import { Retain } from '../../../atoms/Retain/Retain'
import { RetainBehaviorModifier } from '../../../atoms/Retain/constants/modifiers'

interface Props extends HTMLAttributes<HTMLDivElement> {
    children?: ReactElement | ReactElement[]
    paneType: LayoutSidebarPaneType
    customRetainBehaviorModifier?: RetainBehaviorModifier
}

export const LayoutSidebarPaneRSC = ({
    paneType,
    children,
    customRetainBehaviorModifier,
    ...props
}: Props): ReactElement => {
    if (!paneType) {
        console.error('paneType is required for the Layout to read it.')
    }

    return (
        <div
            {...props}
            className={`o-layout__sidebar o-layout__sidebar--${getPaneTypeClassModifier(paneType)} ${props.className ?? ''
                }`}
        >
            <Retain
                behaviorModifiers={[customRetainBehaviorModifier ?? getRetainBehaviorModifierForPane(paneType)]}
                className="h-full"
                behaviorOnly
            >
                {children ?? <></>}
            </Retain>
        </div>
    )
}
